import TmrBaseResource from './TmrBaseResource'

export default class MadeFors extends TmrBaseResource {
  static endpoint = '/madeFors'
}
